function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: styles["icon"] || "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M605.867 128h-8.534v136.533c0 42.667 34.134 76.8 76.8 76.8h136.534V332.8L605.867 128z",
  fill: "#ec6f41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M674.133 384c-68.266 0-119.466-51.2-119.466-119.467V128H290.133c-68.266 0-119.466 51.2-119.466 119.467v529.066c0 68.267 51.2 119.467 119.466 119.467H691.2c64 0 119.467-51.2 119.467-119.467V384H674.133zM332.8 477.867h192c17.067 0 34.133 12.8 34.133 34.133 0 17.067-12.8 34.133-34.133 34.133h-192c-21.333 0-34.133-17.066-34.133-34.133s12.8-34.133 34.133-34.133zM648.533 716.8H332.8c-21.333 0-34.133-17.067-34.133-34.133s12.8-34.134 34.133-34.134h320c17.067 0 34.133 12.8 34.133 34.134-4.266 17.066-17.066 34.133-38.4 34.133z",
  fill: "#ec6f41"
}));